import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/** Legacy page-2 route — redirect to the single merged property details page. */
const ViewPropertyNextPage = () => {
  const navigate = useNavigate();
  const { property_id = "" } = useParams() || {};

  useEffect(() => {
    navigate(`/viewproperty/${property_id}`, { replace: true });
  }, [navigate, property_id]);

  return null;
};

export default ViewPropertyNextPage;
